import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        headerHighLightIndex: localStorage.getItem('headerHighLightIndex') ? parseInt(localStorage.getItem('headerHighLightIndex')) : 0,
    },
    mutations: {
        saveHeaderHighLightIndex(state, payload) {
            localStorage.setItem('headerHighLightIndex', payload);
            state.headerHighLightIndex = payload;
        },
    },
    actions: {

    }
})
